import { useEffect, useMemo, useState } from "react";
import AddMember from "./addMember";
import GuestModal from "./guestModal";
import swal from 'sweetalert2';
import { bookTeeTime, updateTeeTime, releasePendingTeeTime, deleteTeeTimeBook, getUserDetailsByID, getTeeTimeBook } from "../api/teeTimeAPI";
import { getAuthState } from "../../assets/scripts/login-util";
import AddGSTNumber from "./addGSTNumber";
import { initiatePayment } from "../api/paymentAPI";
import FeeSummary from "./feeSummary";
import { calculateGreenFee } from "./useGreenFeeCalculator";
import { useHistory } from "react-router-dom"

const BookingModal = (props) => {//bookingMembers,teeTimeBookData,greenFeeMaster,SelectedDate,onDismissModal
  let timerInterval;
  const { user } = getAuthState();
  const navigate = useHistory();
  const COUNTER_EXPIRY = 60*3;
  
    const [timer,        setTimer]        = useState('3:00');    
    const [addModal,            setAddModal]        = useState(false);
    const [members,             setMembers]         = useState([]);//use for getting selected member from member modal
    const [userList,            setUserList]         = useState([]);//use for getting selected member from member modal
    const [comment,             setComment]         = useState();
    const [hole,                setHole]            = useState(props.teeTimeBookData?.Hole ?? 18);
    const [addGuest,            setAddGuest]        = useState(false);
    const [showGSTModal,        setShowGSTModal]    = useState(false);
    const [selectedCompany,     setSelectedCompany] = useState(null);
    const [refID, setRefID] = useState(null);
    const [greenFeeList,      setGreenFeeList]  = useState(props.greenFeeMaster || []);
    const [greenFeeMasterList,      setGreenFeeMasterList]  = useState(props.greenFeeMaster || []);
    const [rateDetails, setRateDetails] = useState({});
    const [paymentMethod, setPaymentMethod] = useState("0"); 
    const [cartAvailability, setCartAvailability] = useState(props.cartAvailability || 0); 
  
    const day = useMemo(() => moment(props.SelectedDate, 'YYYY-MM-DD').day(), [props.SelectedDate]);

    const isWeekend = useMemo(() => {
        return (day === 6 || day === 0 || (props.Holiday !== null && props.Holiday !== undefined)) ? "Y" : "N";
    }, [day, props.Holiday]);
  
  useEffect(() => {
    if (Array.isArray(props.bookingMembers) && props.bookingMembers.length === 0) return; 
      const loadData = async () => {
        const res = await fetchTeeTimeBook(props.SelectedDate);
      };
    loadData();
  }, [props.bookingMembers]);

  useEffect(() => {
      if (props.action === "a") {
        bookTimer();
        getUserDetails();
      }
      $('#modalBook').modal({ backdrop: 'static', keyboard: false });
      $('#modalBook').on('hidden.bs.modal', function () {
      $('.modal').hasClass('show') && $('body').addClass('modal-open');
      props.onDismissModal(false);
      });
    
      return () => clearInterval(timerInterval); 
    }, []);

    useEffect(() => {
      const handleBeforeUnload = (e) => {
        if (props.action === "a") {
          e.preventDefault();
          releaseTeeSlot();
          $('#modalBook').modal('hide');
        }
      };
    
      window.addEventListener("beforeunload", handleBeforeUnload);
    
      return () => {
        window.removeEventListener("beforeunload", handleBeforeUnload);
      };
    }, [props.action, props.teeTimeBookData]);
  

  const fetchTeeTimeBook = async (params) => {
      try {
          let dateToFetch = params; 
                                              
          /**@listens - selectedDate < serverDate -> sends serverDate || selected Date */
          // if((pageData?.ServerDate) && moment(dateToFetch).isBefore(pageData.ServerDate))
          //     dateToFetch = pageData?.ServerDate;
                      
        const response = await getTeeTimeBook(moment(dateToFetch).format('YYYY-MM-DD'));
        setGreenFeeMasterList(response.GreenFeeMaster)
        setCartAvailability(response.CartStatus?.Available);
        return response;
          
      } catch (err) {
          swal.fire({icon: "error",titleText: "Error!",text: err.message});
          return;  
      }
  }

  useEffect(() => {
    const updated = calculateGreenFee(userList,hole,props.SelectedDate,props.Holiday,greenFeeMasterList,setGreenFeeList,setRateDetails);
    setUserList(updated)
    }, [hole])
  
    
    useEffect(() => {
      if (addModal) $('#modalBook').addClass('modal-blur');    
    }, [addModal]);
 
    const bookTimer =()=> {
      // let t = 179; // 3 minutes in seconds
      let t = COUNTER_EXPIRY; // 3 minutes in seconds

      timerInterval = setInterval(()=>{
          if(t > 0){
              const d  = (t % (60 * 60));
              const ds = Math.ceil(d % 60);
              const ms = { m: Math.floor(d / 60), s: ds < 10 ? (`0${ds}`): ds };
              t = t - 1;
              setTimer(`${ms.m}:${ms.s}`);                
          }else{
              t = 0;
              if (timerInterval) clearInterval(timerInterval);
              setTimer('Time Expired');
              swal.close();
              $('#modalBook').modal('hide');
                return swal.fire({ icon: 'error', timer: 1500, showConfirmButton: false, titleText: 'Booking Time Expired..!'});
          }
      }, 1000);
  }
  
    const getUserDetails = async () => {
    const { user } = getAuthState();
      const { User } = await getUserDetailsByID(user.id);
    
    if (User) {
        const isSubscriptionExpired = User.SubscriptionExpiresOn ? moment(User.SubscriptionExpiresOn).isBefore(moment(props.SelectedDate)) : true;
        const isMembershipExpired = User.MembershipExpiresOn ? moment(User.MembershipExpiresOn).isBefore(moment(props.SelectedDate)) : true;
        const isHolidayCondition = User.SubCategoryID === 7 && isWeekend === "Y";
        const isValidMember = (isSubscriptionExpired || isMembershipExpired || isHolidayCondition) ? 'N' : 'Y';
        const initialMember = [{
            UserID: User.ID,
            UserName: User.UserName ||
            `${User?.FirstName || ""} ${User?.MiddleName || ""} ${
              User?.LastName || ""
            } (${User.MembershipNo})`.trim() ||
            "Unknown User",
            UserType: 'User',
            CategoryID: User.CategoryID || 1,
            SubCategoryID: User.SubCategoryID || 1,
            IsValidMember: isValidMember,
            IsSubscriptionExpired: isSubscriptionExpired,
            IsMembershipExpired: isMembershipExpired,
            SubscriptionExpiresOn: User.SubscriptionExpiresOn,
            MembershipExpiresOn: User.MembershipExpiresOn,
            // IsCaddyRequired: "Y",
            // IsDisabled: true,
          // IsChecked: true,
            IsCartRequired: "N",
            IsCaddyRequired: "N",
            IsChecked: false,
            IsCartUpdated: false,
            MembershipNo: User.MembershipNo || '',
        }];
      const updatedMember = calculateGreenFee(initialMember, hole, props.SelectedDate, props.Holiday, greenFeeMasterList, setGreenFeeList, setRateDetails);
        setMembers(updatedMember);
        setUserList(updatedMember);
      }
    }

    const removeMemberHandler = (index) => {
        setMembers((prev) => {
          let newMembers = prev.filter((_, i) => i !== index);
          newMembers = calculateGreenFee(newMembers,hole,props.SelectedDate,props.Holiday,greenFeeMasterList,setGreenFeeList,setRateDetails);

            setUserList(newMembers);
            return newMembers;
        });
    };
  
    const updateMembersAndCalculate = (newMembers) => {

        newMembers = calculateGreenFee(newMembers,hole,props.SelectedDate,props.Holiday,greenFeeMasterList,setGreenFeeList,setRateDetails);

        setMembers(newMembers);
        setUserList(newMembers);
      };

    const userUpdateCart = (rowIndex, isChecked) => {

      let users = [...userList];
      users = users.map((user, i) => {
          if (i === rowIndex) {
            if (isChecked) {
              return {
                ...user,
                IsCartRequired: "Y",
                IsCaddyRequired: "Y",
                IsChecked: isChecked,
                IsCartUpdated: true,
              };
            } else {
              return {
                ...user,
                IsCartRequired: "N",
                IsCaddyRequired: "N",
                IsChecked: isChecked,
                IsCartUpdated: false,
              };
            }
          }
        return user;
      });
      const m = calculateGreenFee(users,hole,props.SelectedDate,props.Holiday,greenFeeMasterList,setGreenFeeList,setRateDetails);

      setMembers(m)
      setUserList(m)
    };

  // handlers
    const handleHoleChange = ({ target }) => {
      setHole(parseInt(target.value));
    };

    const handleComment = (c) => setComment(c);

    const handlePaymentMethodChange = (e) => {
      setPaymentMethod(e.target.value);
    };
  
    const handleShowGSTModal = () => {
        setShowGSTModal(true);
        if (members.length > 0) {
            setRefID(members[0].UserID);
        }
    };

    //warnings -------------
  const addMemberHandler = (type) => {
        if((members.length + props?.bookingMembers?.length) > 3){
            swal.fire({ icon: 'warning', buttonsStyling: false, text: 'Maximum 4 users are allowed'});            
            return;
        } else  {
            if(type === "guest")
                setAddGuest(true);
            else
                setAddModal(true);
        }
    };

    const releaseTeeSlot = async()=> {
      try {      
          await releasePendingTeeTime(props.teeTimeBookData.ID); // release api 
      } catch (err) {
          swal.fire({ icon: "error",titleText: "Error!",text: err.message });
          return;
      }
    }


    const onBookingModalClose = () => {
        if(props.action !== "a") return $('#modalBook').modal('hide');        

        swal.fire({
            icon: 'warning',
            titleText: 'Are you sure, you want to close, your teetime will be released?',           
            showCancelButton: true,
            confirmButtonText: 'Yes',           
            cancelButtonText:'No'
        }).then(async(result) => {
            if (result.isConfirmed) {
              $('#modalBook').modal('hide');   
              releaseTeeSlot();
            } 
        });
    };

  const cancelBooking = async () => {    
        swal.fire({
            icon: 'warning',
            titleText: 'Are you sure, you want to cancel?',           
            showCancelButton: true,
            confirmButtonText: 'Yes',           
            cancelButtonText:'No'
        }).then(async(result) => {
            
          if (result.isConfirmed) {
                try {
                  const book = props.teeTimeBookData;        
                    swal.fire({
                        titleText: 'Loading',
                        text: 'Please Wait...',
                        showConfirmButton: false,
                        allowOutsideClick: false,
                        onOpen: () => {
                            swal.showLoading();
                        }
                    });

                    await deleteTeeTimeBook(book.ID, comment);
            
                    swal.close();
                    $('#modalBook').modal('hide');
                    swal.fire({ 
                        icon: 'success', 
                        timer: 1500, 
                        showConfirmButton: false,
                        titleText: 'TeeTime Cancelled Successfully',
                    });

                    props.refetchTeeTime();                                
                } catch (err) {
                    swal.close();
                    swal.fire({ icon: "error", titleText: "Error!", text: err.message });
                    return;
                }                                    
            } 
        });
    };

  
    const postBooking = async() => { 
      try {
          if (timer == "Time Expired" && props.action == 'a') {
              swal.close();
              $('#modalBook').modal('hide');
              return swal.fire({ icon: 'error', timer: 1500, showConfirmButton: false, titleText: 'Booking Time Expired..!'});
          }
        
          
          const book = props.teeTimeBookData;
          book.CompanyID = selectedCompany?.ID || '';
          book.PaymentMethod = paymentMethod;
          book.Discount = rateDetails?.discount || 0;
          book.Comment = comment;
          if (props.bookingMembers?.length === 0) {
            book.Hole = hole;
          }
          
          const users = userList.map(m => ({ ...m, TeeTimeBookID: book.ID }));  
          if (users.length === 0) return;
              
          // Show loading while processing booking
          swal.fire({
              titleText: 'Processing Booking',
              text: 'Please Wait...',
              showConfirmButton: false,
              allowOutsideClick: false,
              onOpen: () => {
                  swal.showLoading();
              }
          });

          const bookingResponse = props.action === 'e'
            ? await updateTeeTime(users)
            : await bookTeeTime(users, book);
        
        //---------------uncomment this testing
        
        if (paymentMethod === "1" && bookingResponse?.Message == "success" && !!bookingResponse?.PaymentLink) {
            swal.close();
            $('#modalBook').modal('hide');
            // sessionStorage.setItem('PaymentLink', bookingResponse.PaymentLink);
            navigate.push(`${bookingResponse?.PaymentLink}`);
            return;
        } else if (paymentMethod === "0" && bookingResponse?.Message == "success" && !!bookingResponse?.PaymentLink) {
            swal.close();
            $('#modalBook').modal('hide');
            window.location.href = bookingResponse?.PaymentLink;
            return;
          } 

        // ----------------------------
        
        // ----------------testing ---------------
        //     swal.fire({ 
        //           icon: 'success', 
        //           timer: 1500, 
        //           showConfirmButton: false,
        //           titleText: `TeeTime ${(props.action === 'e') ? 'Updated': 'Confirmed'} Successfully`,
        //           timerProgressBar: true
        //       });
        //       $('#modalBook').modal('hide');   
        // props.refetchTeeTime();
        // ----------------testing end ---------------
        
          
          
          // Check if booking was successful and has payment link
          // if (bookingResponse && bookingResponse.payment_link && bookingResponse.Message === "success") {
          //     const orderId = bookingResponse.OrderID;
              
          //     // Clear any previous payment status
          //     localStorage.removeItem(`payment_status_${orderId}`);
              
          //     // Set up listener for payment status updates
          //     const handleStorageChange = (e) => {
          //         if (e.key === `payment_status_${orderId}`) {
          //             const paymentData = JSON.parse(e.newValue || '{}');
                      
          //             window.removeEventListener('storage', handleStorageChange);
                      
          //             if (paymentData.status === 'success') {
          //                 // Show success popup with auto-close
          //                 swal.fire({
          //                     icon: 'success',
          //                     title: 'Payment Successful!',
          //                     html: `
          //                         <div style="text-align: left; padding: 10px;">
          //                             <p><strong>Transaction ID:</strong> ${paymentData.transactionId || bookingResponse.Payload?.id || orderId}</p>
          //                             <p><strong>Order ID:</strong> ${orderId}</p>
          //                             <p><strong>Amount:</strong> ₹${bookingResponse.Amount}</p>
          //                             <p><strong>Business:</strong> ${bookingResponse.Payload?.sdk_payload?.payload?.displayBusinessAs || 'OXFORD GOLF AND RESORTS PVT LTD'}</p>
          //                             <p><strong>Status:</strong> Payment Completed Successfully</p>
          //                         </div>
          //                     `,
          //                     timer: 3000, // Auto-close after 3 seconds
          //                     showConfirmButton: true,
          //                     confirmButtonText: 'OK',
          //                     timerProgressBar: true
          //                 }).then(() => {
          //                     props.refetchTeeTime();
          //                 });
          //             } else if (paymentData.status === 'failed') {
          //                 swal.fire({
          //                     icon: 'error',
          //                     title: 'Payment Failed!',
          //                     text: paymentData.message || 'Your payment was not successful. Please try again.',
          //                     timer: 3000,
          //                     showConfirmButton: true,
          //                     timerProgressBar: true
          //                 });
          //             } else {
          //                 swal.fire({
          //                     icon: 'info',
          //                     title: 'Payment Cancelled',
          //                     text: 'Payment process was cancelled.',
          //                     timer: 2000,
          //                     showConfirmButton: false,
          //                     timerProgressBar: true
          //                 });
          //             }
                      
          //             // Clean up
          //             localStorage.removeItem(`payment_status_${orderId}`);
          //         }
          //     };
              
          //     window.addEventListener('storage', handleStorageChange);
              
          //     // Open payment link in new window
          //     const paymentWindow = window.open(
          //         bookingResponse.payment_link, 
          //         'PaymentWindow', 
          //         'width=800,height=600,scrollbars=yes,resizable=yes'
          //     );
              
          //     // Fallback: Monitor window closure without storage event
          //     const checkWindowClosure = setInterval(() => {
          //         if (paymentWindow.closed) {
          //             clearInterval(checkWindowClosure);
                      
          //             // Wait a moment for storage event, then show cancelled if no status received
          //             setTimeout(() => {
          //                 const paymentStatus = localStorage.getItem(`payment_status_${orderId}`);
          //                 if (!paymentStatus) {
          //                     window.removeEventListener('storage', handleStorageChange);
          //                     swal.fire({
          //                         icon: 'info',
          //                         title: 'Payment Window Closed',
          //                         text: 'Payment process was interrupted.',
          //                         timer: 2000,
          //                         showConfirmButton: false,
          //                         timerProgressBar: true
          //                     });
          //                 }
          //             }, 1000);
          //         }
          //     }, 1000);
              
          //     // Cleanup after timeout
          //     setTimeout(() => {
          //         clearInterval(checkWindowClosure);
          //         window.removeEventListener('storage', handleStorageChange);
          //         localStorage.removeItem(`payment_status_${orderId}`);
          //         if (!paymentWindow.closed) {
          //             paymentWindow.close();
          //         }
          //     }, 600000); // 10 minutes
              
          // } else {
          //     // Regular booking success (no payment required)
          //     swal.fire({ 
          //         icon: 'success', 
          //         timer: 1500, 
          //         showConfirmButton: false,
          //         titleText: `TeeTime ${(props.action === 'e') ? 'Updated': 'Confirmed'} Successfully`,
          //         timerProgressBar: true
          //     });
          //     props.refetchTeeTime();
          // }
          
      } catch (err) {
          swal.close();
          swal.fire({ 
              icon: "error", 
              titleText: "Error!", 
              text: err.message 
          });
          return;
      }
  };
  
    return (
      <>
        <div
          id="modalBook"
          className="modal fade modal-responsive"
          tabIndex="-1"
          role="dialog"
        >
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <div className="modal-header">
              <div className="col">
                            <div className="col-xs-5 ">
                                <h4 id="modalBookTitle" className="modal-title">Book</h4>
                            </div>
                  <div className={`col-xs-7 ${window.innerWidth < 720 ? '5' : timer == 'Time Expired' ? '5' : '50'}`} style={{ width: "100%", margin:"0 auto"}}>
                                {(props.action == "a") && ( <h5 id="otpTimer" className="margin-t10 margin-l40" style={{color: 'Red',margin:"0 auto", fontSize: '23px', fontWeight: '500', width: `${timer == 'Time Expired' ? '160px' : '70px'}`, height:' 43px', border: '1px solid rgb(128 128 128 / 12%)', padding: '10px', boxShadow: '#9db2b99c 1px 4px 5px', backgroundColor: 'rgb(128 128 128 / 32%)'}}>{timer}</h5> )}
                            </div>
                        </div>
                {/* <div className="row">
                  <div className="col-xs-5">
                    <h4 id="modalBookTitle" className="modal-title">
                      Book
                    </h4>
                  </div>
                </div> */}
              </div>
              <div className="modal-body padding-t0">
                <div id="ModalHolder1">
                  <div id="bookingForm" role="form">
                    <div className="form-group">
                      <div className="input-group">
                        <span className="input-group-addon">
                          {" "}
                          <i className="fa fa-lock fa-lg"></i>{" "}
                        </span>
                        <input
                          id="lblDate"
                          name="lblDate"
                          className="form-control"
                          type="text"
                          readOnly="readOnly"
                          placeholder="Date"
                          value={moment(props.SelectedDate).format(
                            "DD-MMM-YYYY"
                          )}
                        />
                      </div>
                    </div>

                    <div id="pnlSlot1" className="form-group">
                      <div className="input-group">
                        <span className="input-group-addon">
                          {" "}
                          <i id="icSlot1" className="fa fa-lock fa-lg"></i>
                        </span>
                        <input
                          id="lblSlot"
                          name="lblSlot"
                          className="form-control"
                          type="text"
                          readOnly="readOnly"
                          data-id=""
                          placeholder="Slot"
                          value={props.teeTimeBookData.Slot}
                        />
                      </div>
                    </div>

                    {(props.action === "a" ||
                      props?.editValidation?.IsEdit) && (
                      <>
                        <div
                          id="pnlMember"
                          className="form-group margin-t20 margin-b0"
                        >
                          <div className="row">
                            <div className="col-xs-12">
                              <div className="col-xs-6">
                                <button
                                  id="btnAddMember"
                                  className="btn btn-default btn-block btn-add padding-2"
                                  type="button"
                                  onClick={() => addMemberHandler("member")}
                                >
                                  Add Member
                                </button>
                              </div>
                              <div className="col-xs-6">
                                <button
                                  id="btnAddGuest"
                                  className="btn btn-default btn-block btn-add padding-2"
                                  type="button"
                                  onClick={() => addMemberHandler("guest")}
                                >
                                  Add Guest
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                  <div className="row">
                    <div className="col-xs-12">
                      <hr className="divider" />
                    </div>
                  </div>
                  {/* <div className="form-group">
                    <div className="col-sm-10 padding-0 padding-l10 margin-tb10">
                      <label className="inline">
                        <input
                          type="radio"
                          id="redio18"
                          className="redio18"
                          name="hole"
                          value="18"
                          checked={hole === 18}
                          onChange={handleHoleChange}
                        />
                        <span className="lbl">18 Holes</span>
                      </label>
                      {(isWeekend!=='Y') && (
                          <label className="kt-radio kt-radio--brand padding-l10">
                            <input
                              type="radio"
                              id="radio9"
                              className="radio9"
                              name="hole"
                              value="9"
                              checked={hole === 9}
                              onChange={handleHoleChange}
                            />
                            <span className="lbl">9 Holes</span>
                          </label>
                        )}
                    </div>


                  </div> */}
                  {props?.bookingMembers.length > 0 ? (
                    <div className="form-group">
                      <div className="col-sm-10 padding-0 padding-l10 margin-tb10">
                        <label className="inline">
                          <input
                            type="radio"
                            id="radio18"
                            className="radio18"
                            name="hole"
                            value={hole}
                            checked={true}
                            disabled
                          />
                          <span className="lbl">{hole} Holes</span>
                        </label>
                      </div>
                    </div>
                    
                  ) : (
                    <div className="form-group">
                      <div className="col-sm-10 padding-0 padding-l10 margin-tb10">
                        <label className="inline">
                          <input
                            type="radio"
                            id="radio18"
                            className="radio18"
                            name="hole"
                            value="18"
                            checked={hole === 18}
                            onChange={handleHoleChange}
                          />
                          <span className="lbl">18 Holes</span>
                        </label>
                        {isWeekend !== 'Y' && (
                          <label className="kt-radio kt-radio--brand padding-l10">
                            <input
                              type="radio"
                              id="radio9"
                              className="radio9"
                              name="hole"
                              value="9"
                              checked={hole === 9}
                              onChange={handleHoleChange}
                            />
                            <span className="lbl">9 Holes</span>
                          </label>
                        )}
                      </div>
                    </div>
                  )}

                  
                  <strong className="pull-right margin-tb1">
                    Available Carts: <span id="lblAvailableCart"></span>{" "}
                    <span id="lblAvailableCaddy">{cartAvailability}</span>
                  </strong>
                  <div className="col-sm-10 padding-0 margin-tb10"> { props?.bookingMembers?.length > 0 && <strong className="">NEW Members</strong>}</div>
                  <table id="table-user" className="table table-bordered table-hover"> 
                    <thead className="thin-border-bottom">
                      <tr>
                        <th>Players</th>
                        <th>Cart</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                    {userList.length > 0 && userList.map((m, i) => {
                      return (
                        <tr key={i}>
                          <td>
                            {m.UserName}
                            {m.IsCartRequired === 'Y' && (
                              <small className="cart-fee text-fee">
                              {Number(m.greenFee) > 0
                                ? `Green Fee: ₹ ${m.greenFee}`
                                : ""}
                              {" "}
                              Cart: ₹ {m.cartFee}
                              {" "}
                              Caddy: ₹ {m.caddyFee}
                            </small>
                            )}
                            {
                              ((m.IsValidMember === "Y" || m.CategoryID !== 1) ? null : (
                                  m.SubCategoryID === 7 && isWeekend === "Y" ? (
                                    <small className="text-coupon text-danger"> Weekday Member</small>
                                  ) : (
                                    <small className="text-coupon text-danger"> { m.IsSubscriptionExpired ? 'Subscription Expired!' : m.IsMembershipExpired ? 'Membership Expired!': null}</small>
                                  )
                                )
                              ) 
                                // : (m.IsValidMember === "Y" || m.UserType === "Guest" || m.UserType === "Player") &&
                                //   ( m.SubCategoryID === 7 && isWeekend === "Y" ? ( <small className="text-coupon text-danger">Weekday Member</small> ) : ( <small className="text-coupon text-danger">9Subscription Expired!</small> )
                                // )
                            }
                          </td>
                          <td>
                            <input
                              className="user-cart"
                              name="user-cart"
                              type="checkbox"
                              checked={m.IsChecked}
                              disabled={m.IsDisabled}
                              onChange={(e) => userUpdateCart(i,e.target.checked)}
                            />
                            <span className="lbl"></span>
                          </td>
                          {( m.UserType == "UsersGuest" || m.UserID != user.id) &&
                            (props.action === "a" || props?.editValidation?.IsEdit) && (
                              <td style={{ width: "10%" }}>
                                <center>
                                  <button
                                    className="btn btn-xs btn-danger btn-user-delete"
                                    type="button"
                                    onClick={() => removeMemberHandler(i)}
                                  >
                                    <i className="fa fa-trash-o icon-only"></i>
                                  </button>
                                </center>
                              </td>
                            )}
                        </tr>
                      );
                    })}
                    </tbody>
                  <tfoot>
                      <tr className="text-center">
                        <td colSpan="4">
                          <span className="lbl text-center margin-0">
                            * Cart fees includes sanitization fees
                          </span>
                        </td>
                      </tr>

                      <tr className="text-center">
                        <td colSpan="4">
                          <span>
                            <a
                              id="lblGstNo"
                              className={`lbl text-center margin-0 ${
                                selectedCompany ? "text-success" : ""
                              }`}
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                handleShowGSTModal();
                              }}
                            >
                              {selectedCompany
                                ? `${selectedCompany.CompanyName}: ${selectedCompany.GSTNumber}`
                                : "Add GST Number"}
                            </a>
                          </span>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                  <div className="col-sm-10 padding-0 margin-tb10"></div>
                  {
                    props?.bookingMembers?.length > 0 && (
                      <>
                        <div className="col-sm-10 padding-0 margin-tb5">
                          <strong className="">Co-Players</strong>
                        </div>
                        <table id="table-user" className="table table-bordered table-hover" >
                            <thead className="thin-border-bottom">
                              <tr>
                                <th>Players</th>
                                <th>Category</th>
                                <th>Cart</th>
                              </tr>
                            </thead>
                          <tbody>
                            {props?.bookingMembers?.length > 0 && props?.bookingMembers?.map((m, i) => {
                              return (
                                <tr key={i}>
                                  <td>
                                    {m.UserName}
                                  {/* {!(m.IsValidMember === "Y" || m.UserType === "Guest" || m.UserType === "Player") && (
                                    m.SubCategoryID === 7 && isWeekend === "Y" ? (
                                        <small className="text-coupon text-danger">Weekday Member</small>
                                      ) : (
                                        <small className="text-coupon text-danger">Subscription Expired!</small>
                                      )
                                    )} */}
                                    {/* {(m.isValidMember === 'Y' || m.type === 'Guest' || m.type === 'Player') ? null : (
                                          m.subCategoryID === 7 && isWeekend === 'Y' ? (
                                            <small className="text-coupon text-danger"> Weekday Member</small>
                                          ) : (
                                            <small className="text-coupon text-danger"> Subscription Expired!</small>
                                          )
                                        )} */}
                                  </td>
                                  <td>
                                    {m.SubCategoryName}
                                  </td>
                                  <td>
                                    <input
                                      className="user-cart"
                                      name="user-cart"
                                      type="checkbox"
                                      checked={m.IsCaddyRequired == 'Y'}
                                      disabled={true}
                                    />
                                    <span className="lbl"></span>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </>
                    )
                  }
                  
                    
                  <hr className="divider" />
                  {rateDetails && (
                    <FeeSummary
                    rateDetails={rateDetails}
                    />
                  )}
                  <div className="form-group">
                    <textarea
                      name="txtComment"
                      rows="2"
                      cols="20"
                      id="txtComment"
                      className="form-control"
                      placeholder="Comments"
                      value={comment || ""}
                      onChange={({ target }) => handleComment(target.value)}
                    ></textarea>
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <div className="col-sm-12 margin-b10">
                  <label className="inline">
                    <input
                      type="radio"
                      className="ace"
                      id="redioPaymentGateway"
                      name="payment"
                      checked={paymentMethod === "0"}
                      value="0"
                      onChange={handlePaymentMethodChange}
                    />
                    <span className="lbl">Payment Gateway</span>
                  </label>
                  <label className="inline margin-l10">
                    <input
                      type="radio"
                      className="ace"
                      id="redioCashCard"
                      name="payment"
                      checked={paymentMethod === "1"}
                      value="1"
                      onChange={handlePaymentMethodChange}
                    />
                    <span className="lbl">Cash Card</span>
                  </label>
                </div>
                <button
                  type="button"
                  id="btnModalClose"
                  className="btn btn-default btn-booking-close margin-r5"
                  onClick={onBookingModalClose}
                >
                  {" "}
                  Close{" "}
                </button>

                {props.action === "e" ? (
                  <>
                    {props?.editValidation?.IsCancel && (
                      <button
                        type="button"
                        id="btnCancel"
                        name="btnCancel"
                        className="btn btn-danger margin-r5"
                        onClick={cancelBooking}
                      >
                        {" "}
                        Cancel{" "}
                      </button>
                    )}

                    {props?.editValidation?.IsEdit && (
                      // <button
                      //   type="button"
                      //   id="btnUpdate"
                      //   name="btnUpdate"
                      //   className="btn btn-success"
                      //   onClick={postBooking}
                      // >
                      //   {" "}
                      //   Update{" "}
                      // </button>

                      <button
                        type="button"
                        id="btnSave"
                        name="btnSave"
                        className="btn btn-success"
                        onClick={postBooking}
                      >
                        Proceed To Pay{" "}
                        {rateDetails.finalAmount && (
                          <>
                            ₹&nbsp;{rateDetails.finalAmount}
                          </>
                        )}
                      </button>

                    )}
                  </>
                ) : (
                  <button
                    type="button"
                    id="btnSave"
                    name="btnSave"
                    className="btn btn-success"
                    onClick={postBooking}
                  >
                    {" "}
                    Proceed To Pay &#8377;&nbsp;{rateDetails.finalAmount}
                  </button>
                )}
                <p className="margin-b0 margin-t10">
                  By continuing you agree to our
                  <a href="/booking-terms" target="_blank">
                    {" "}
                    Booking Terms
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>

        {addModal && (
          <AddMember
            show={addModal}
            from="#modalBook"
            SelectedDate={props.SelectedDate}
            isWeekend={isWeekend}
            // members={members}
            members={userList}
            setMembers={updateMembersAndCalculate}
            onDismissModal={() => setAddModal(false)}
            otherMembers={props.bookingMembers}
          />
        )}

        {addGuest && (
          <GuestModal
            show={addGuest}
            from="#modalBook"
            members={members}
            setMembers={updateMembersAndCalculate}
            onDismissModal={() => setAddGuest(false)}
          />
        )}
        {showGSTModal && (
          <AddGSTNumber
            setSelectCompany={setSelectedCompany}
            refID={refID}
            selectCompany={selectedCompany}
            onDismissModal={setShowGSTModal}
          />
        )}
      </>
    );
};

export default BookingModal;